/**
 * 基础-其他类-service
 * @author by zhp 2020-08-15 
 */
import {
	POST,
	GET
} from './service.config.js'
import md5 from 'js-md5'
import axios from "axios";

/**
 * 获取附近的取货点
 * @param lat
 * @param lng
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getReceiveShopListService = (lat, lng, page, limit, code) => POST('btrbasic/getReceiveShop', {
	lat,
	lng,
	page,
	limit,
	search: code
});

/**
 * 获取领货点详情
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getReceiveShopDetailService = shopId => POST('btrbasic/getReceiveShopDetail', {
	shop_id: shopId,
});

/**
 * 扫码充值，微信支付
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param openid
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const weChatPayService = (shopId, tel, amount, cash, total, openid, type) => POST('sdl/underLineWxPay', {
	shop_id: shopId,
	amount,
	tel,
	use_djj: cash,
	total_sum: total,
	openid,
	type,
});
export const getQyfwCate = () => GET('btrbasic/getQyfwCate');

/**
 * 获取附近的企业服务
 * @param lat
 * @param lng
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getQyfwList = (lat, lng, page, limit, code, typeId) => POST('btrbasic/getQyfwList', {
	lat,
	lng,
	page,
	limit,
	search: code,
	typeId
});

/**
 * 企业服务详情
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getQyfwDetailService = shopId => POST('btrbasic/getQyfwDetail', {
	shop_id: shopId,
});

/**
 * 获取我的红包消费记录
 */
export const getUserRedList = (userId, page) => POST('btrbasic/getUserRedList', {
	uid: userId,
	page,
});

/**
 * 获取我的红包使用记录
 */
export const getUserRedUseList = (userId, page) => POST('btrbasic/getUserRedUseList', {
	uid: userId,
	page,
});

/**
 * 扫码付款记录
 */
export const getUserPayList = (userId, page) => POST('btrbasic/getUserPayList', {
	uid: userId,
	page,
});

/**
 * 获取我的红包使用记录
 */
export const doUserShareService = (fromOpenId, toOpenId) => POST('btrbasic/doUserShare', {
	fromOpenId,
	toOpenId,
});

/**
 * 获取我的分享
 */
export const getMyshareuser = (userId, page) => POST('btrbasic/getMyshareuser', {
	userId,
	page
});
/**
 * 获取我的分享奖励
 */
export const getShareusermoney = (userId, page) => POST('btrbasic/getMysharemoney', {
	userId,
	page
});

/**
 * 获取一级特价分类
 */
export const getTjcate1 = () => GET('btrbasic/getTjcate1');

/**
 * 获取二级特价分类
 */
export const getTjcate2 = (pid) => POST('btrbasic/getTjcate2', {
	pid,
});

/**
 * 获取二级特价分类
 */
export const getShopName = (shopId) => POST('btrbasic/getShopName', {
	shopId,
});

/**
 * 抽奖用户信息
 */
export const getLuckUser = (uid) => POST('newapi/getLuckUser', {
	uid,
});

/**
 * 获取奖品信息
 */
export const getLuckData = () => POST('newapi/getLuckData');

/**
 * 抽奖结束
 */
export const endLuck = (uid, luckey) => POST('newapi/endLuck', {
	uid,
	luckey
});

/**
 * 获取首页活动商家
 */
export const getHomeShops = (lat, lng, cateid) => POST('newapi/getHomeShops', {
	lat,
	lng,
	cateid
});

/**
 * 获取首页活动商家
 */
export const getHomeShopsCate = (id) => POST('newapi/getShopCate', {
	id
});


/**
 * 2980活动，微信支付
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param openid
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const weChatPayService2980 = (shopId, tel, amount, cash, total, openid, type) => POST('newapi/underLineWxPay', {
	shop_id: shopId,
	amount,
	tel,
	use_djj: cash,
	total_sum: total,
	openid,
	type,
});

/**
 * 获取商家活动信息
 */
export const getSdlactivityDetail = (shopid) => POST('newapi/getSdlactivityDetail', {
	shopid
});


/**
 * 商家自有产品
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param openid
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const shopGoodsWxPay = (id, num, shopId, uid, amount, total, openid) => POST('newapi/shopGoodsWxPay', {
	id,
	num,
	shop_id: shopId,
	uid,
	amount,
	total,
	openid,
});

/**
 * 商家特色服务
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param openid
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const shopGoodsOrderWxPay = (id, num, shopId, uid, amount, total, openid, address_id) => POST(
	'newapi/shopGoodsOrderWxPay', {
		id,
		num,
		shop_id: shopId,
		uid,
		amount,
		total,
		openid,
		address_id
	});


/**
 * 获取商家活动信息
 */
export const getMembersetService = (shopid) => POST('newapi/getMemberset', {
	shopid
});

export const memberPay = (id, uid, amount, openid) => POST('newapi/memberPay', {
	id,
	uid,
	amount,
	openid,
});

/**
 * 获取商家活动信息
 */
export const getAfservice = (id) => POST('newapi/getAf', {
	id
});

/**
 * 获取商家活动信息
 */
export const saveAuService = (id, c_name, c_price, num, name, job, tel, t_name, is_marry) => POST('newapi/saveAu', {
	id,
	c_name,
	c_price,
	num,
	name,
	job,
	tel,
	t_name,
	is_marry
});

/**
 * 获取商家活动信息
 */
export const getShopGoodsOrderDetailsService = (id) => POST('newapi/getNewShopGoodsOrderDetail', {
	id
});

/**
 * 获取代理提成记录
 */
export const getDlTclist = (uid,page) => POST('dl/getTclist', {
	uid,
	page
});

/**
 * 获取下级代理
 */
export const getDlSons = (uid,page) => POST('dl/getSonUsers', {
	uid,
	page
});